// In the noise (Miscellaneous/Ops) project the stored reasoning may describe the feature project
// the grouping or ticket almost matched; this prefix keeps it readable as the routing explanation
// in that context. Shared by the grouping-parent header and the per-ticket rows.
export const NOISE_REASONING_PREFIX = 'Routed to miscellaneous/ops — ';
